<template>
  <div id="bidsData">
          <!-- 日期控件 -->
        <HeadControl :titleName="'招标数据'" ref="HeadControl" @changeVal="changeVal" @changDate="changDate" @changePicker="changePicker"></HeadControl>
        <div class="topBox" v-if="aggregation[0]">
            <div class="DataBox">
                <div style="font-size:0.16rem;color:#666666;">投标个数</div>
                <div class="smBox" style="margin-top:0.1rem;">
                    <div style="font-size:0.26rem;color:#333333;">{{aggregation[0].count}}<span style="font-size:0.12rem;">个</span></div>
                    <div class="imgBox" style="width:0.56rem;height:0.55rem;">
                        <img :src="aggregation[0].itemIcon" alt="" style="width:100%;height:100%">
                    </div>
                </div>
            </div>
            <div class="DataBox">
                <div style="font-size:0.16rem;color:#666666;">投标人数</div>
                <div class="smBox" style="margin-top:0.1rem;">
                    <div style="font-size:0.26rem;color:#333333;">{{aggregation[1].totalCount}}<span style="font-size:0.12rem;">人</span></div>
                    <div class="imgBox" style="width:0.56rem;height:0.55rem;">
                        <img :src="aggregation[1].itemIcon" alt="" style="width:100%;height:100%">
                    </div>
                </div>
            </div>
            <div class="DataBox">
                <div style="font-size:0.16rem;color:#666666;">中标个数</div>
                <div class="smBox" style="margin-top:0.1rem;">
                    <div style="font-size:0.26rem;color:#333333;">{{aggregation[2].count}}<span style="font-size:0.12rem;">个</span></div>
                    <div class="imgBox" style="width:0.56rem;height:0.55rem;">
                        <img :src="aggregation[2].itemIcon" alt="" style="width:100%;height:100%">
                    </div>
                </div>
            </div>
            <div class="DataBox">
                <div style="font-size:0.16rem;color:#666666;">中标人数</div>
                <div class="smBox" style="margin-top:0.1rem;">
                    <div style="font-size:0.26rem;color:#333333;">{{aggregation[3].totalCount}}<span style="font-size:0.12rem;">人</span></div>
                    <div class="imgBox" style="width:0.56rem;height:0.55rem;">
                        <img :src="aggregation[3].itemIcon" alt="" style="width:100%;height:100%">
                    </div>
                </div>
            </div>
        </div>
        <div class="BigCenterBox">
            <div class="centerBox">
                <div id="bidsDataEcharts" ref="bidsDataEcharts"></div>
            </div>
        </div>
        <div class="BigBottomBox">
            <div class="BottomBox">
            <div id="ChinaMap" ref="ChinaMap"></div>
            <div class="Ranking">
                <div class="top-Name">
                    <i class="el-icon-s-data"></i>
                    <p class="titleName">TOP10 省份投/中标数量排行</p>
                </div>
                 <ul class="tablist">
                  <li :class="{'active': activeProjectName === 'BID'}" @click="handleClick('BID')">投标个数排行</li>
                  <li :class="{'active': activeProjectName === 'BIDDING'}" @click="handleClick('BIDDING')">中标个数排行</li>
                </ul>
                 <div id="S-dataSort" v-if="RankingDataList.length && activeProjectName === 'BID'">
                    <div class="bottom-Data" >
                        <table class="table-Box">
                            <tr class="herader-Box">
                                <td :width="screenWidth <= 1366 ? 180 : 300" >省份</td>
                                <td width="180" align="center">投标人数（人）</td>
                                <td :width="identification == 'pplet' ? 160 : 140" align="center">投标个数（个）</td>
                            </tr>
                            <tr height="32" v-for="(item,index) in RankingDataList" :key="index">
                                <td>
                                    <div class="dataBox">
                                        <span style="margin-right:10px;" :class="{'red' :item.serialNumber=='1','orange' :item.serialNumber=='2','yellow' :item.serialNumber=='3'}">{{item.serialNumber}}</span>{{item.province}}
                                    </div>
                                </td>
                                <td align="center">{{item.totalCount}}</td>
                                <td align="center">{{item.count}}</td>
                            </tr>                                  
                        </table>
                    </div>                            
                </div> 
                <div id="S-dataSort" v-else-if="RankingDataList.length && activeProjectName === 'BIDDING'">
                    <div class="bottom-Data" >
                        <table class="table-Box">
                            <tr class="herader-Box">
                                <td :width="screenWidth <= 1366 ? 180 : 300" >省份</td>
                                <td width="180" align="center">中标人数（人）</td>
                                <td :width="identification == 'pplet' ? 160 : 140" align="center">中标个数（个）</td>
                            </tr>
                            <tr height="32" v-for="(item,index) in RankingDataList" :key="index">
                                <td>
                                    <div class="dataBox">
                                        <span style="margin-right:10px;" :class="{'red' :item.serialNumber=='1','orange' :item.serialNumber=='2','yellow' :item.serialNumber=='3'}">{{item.serialNumber}}</span>{{item.province}}
                                    </div>
                                </td>
                                <td align="center">{{item.totalCount}}</td>
                                <td align="center">{{item.count}}</td>
                            </tr>                                  
                        </table>
                    </div>                            
                </div>
                <div class="nodata_box" v-else>
                    <img src="https://xmyun.zhoty.com/xmerp/pcadmin/static/images/report_item_nodata.png" />
                    <span>暂无数据</span>
                </div> 
            </div>
            </div>
        </div>
  </div>
</template>

<script>
import * as Urls from '@/helper/Urls';
import HeadControl from '@/components/HeadControl'
import {EchartsformatDate,checkDay} from '@/helper/VueHelper.js'
import China from '../../../static/china'
import {loadScript} from '@/helper/VueHelper';
export default {
    components:{
        HeadControl,
    },
    data() {
        return {
            screenWidth: document.body.clientWidth, // 屏幕宽度
            orgCode:'',
            dataRange:[],
            BidsDataList:'', // 招标投标数量
            aggregation:[], // 汇总数据
            activeProjectName:'BID',
            RankingDataList:'',
            ChanDataList:'',
            identification:''
        };
    },  
    mounted(){
        let _this = this;
        window.onresize = () => {
        return (() => {
            window.screenWidth = document.body.clientWidth; //实时宽度
            _this.screenWidth = window.screenWidth;
        })();
        }; 
        this.identification = this.$route.query.identification;
        // loadScript('https://cdn.jsdelivr.net/npm/echarts@5.3.1/dist/echarts.min.js').then(() => {
        //     console.log('echarts')
        // })
        
    },
    methods:{
        handleClick(type){
            this.activeProjectName = type
            this.getRanking()
        },
        getRanking(){
            let _this = this
            let url = Urls.getEchartsBidsReportDataByProvince
            let params = {
            orgCode:this.orgCode,
            startTime:this.dataRange.length?this.dataRange[0]:'',
            endTime:this.dataRange.length?this.dataRange[1]:'',
            itemCode:this.activeProjectName
            }
            this.$root.doPost(url,params,function(server_data){
                // 用户没有登录
            if( !_this.$root.isUserLogin(server_data)){
            return;
            }

            // 应用错误
            if(server_data.error){
                _this.$root.showGlobalError(server_data.error);
                return;
            }
            _this.RankingDataList = server_data.data
            })
        },
        init(){
            this.$refs.HeadControl.getDatas('month')
            this.$refs.HeadControl.getSysOrg()
        },
        // 获取组织架构ID
        changeVal(val) {
            this.orgCode = val;  
            this.getDataAggregation()  
            this.getBidsDataList()
            this.getRanking()
            this.getChnaDataList()
        },
        changDate(val){
            this.dataRange=val
            this.getDataAggregation()   
            this.getBidsDataList()
            this.getRanking()
            this.getChnaDataList()
            
            this.mapEcharts()
        }, 
        // 时间
        changePicker(val){
            this.dataRange = val
            this.getDataAggregation()     
            this.getBidsDataList()
            this.getRanking()
            this.getChnaDataList()
        },
        getOrgCode(){
            this.$refs.HeadControl.getSysOrg()
        },
        // 获取数据汇总
        getDataAggregation(){
            let _this = this
            let url = Urls.getEchartsBidsReportData
            let params = {
            orgCode:this.orgCode,
            startTime:this.dataRange.length?this.dataRange[0]:'',
            endTime:this.dataRange.length?this.dataRange[1]:'',
            itemCode:''
            }
            this.$root.doPost(url,params,function(server_data){
                // 用户没有登录
            if( !_this.$root.isUserLogin(server_data)){
            return;
            }

            // 应用错误
            if(server_data.error){
                _this.$root.showGlobalError(server_data.error);
                return;
            }
            _this.aggregation = server_data.data.reportList 
            })
        },
        // 获取投标中标数量走势
        getBidsDataList(){
            let _this = this
            let url = Urls.getEchartsBidsReportDataByTrend 
            let params = {
            orgCode:this.orgCode,
            startTime:this.dataRange.length?this.dataRange[0]:'',
            endTime:this.dataRange.length?this.dataRange[1]:'',
            itemCode:''
            }
            this.$root.doPost(url,params,function(server_data){
                // 用户没有登录
            if( !_this.$root.isUserLogin(server_data)){
            return;
            }

            // 应用错误
            if(server_data.error){
                _this.$root.showGlobalError(server_data.error);
                return;
            }
            _this.BidsDataList = server_data.data
            })
        },
        // 投标&中标数量走势报表
        initChart(){
        let series = this.BidsDataList.series
        let Chart = this.$echarts.getInstanceByDom(this.$refs.bidsDataEcharts);
        if (Chart == null) {
            this.myChart = this.$echarts.init(this.$refs.bidsDataEcharts);
        }      
        const option = {
                    textStyle: {
                    fontFamily: 'PingFang-M'
                    },
                    title:{
                    text: '投标&中标数量走势',
                    top:'24',  
                    left:this.$route.query.identification ? '20' : '30',
                    textStyle:{
                        fontWeight:500,
                    }
                    },      
                    grid: {
                        left: this.$route.query.identification ? '52' :'65',
                        right: this.$route.query.identification ? '48' : '50',
                        top:this.$route.query.identification ? '100' : '100',
                        bottom: this.$route.query.identification ? '25' : '50',
                    },
                    tooltip: {
                        show: true,
                        trigger: "axis",  
                        formatter: function (params) {
                            let h = `<div>`;
                            params.forEach(item => {
                                if(item.seriesIndex == 0){
                                    h += ` ${EchartsformatDate(item.axisValue)}</div>
                                        <div>${item.marker}${item.seriesName}：${item.value}个 （${series[item.seriesIndex].number[item.dataIndex]}人）</div>` 
                                }else {
                                if(params.length == 1){
                                h += `<div >${EchartsformatDate(item.axisValue)}</div>`
                                }
                                h += `<div>${item.marker}${item.seriesName}：${item.value}个 （${series[item.seriesIndex].number[item.dataIndex]}人）</div>` 
                            }
                            });

                            return h
                        },
                    axisPointer: {
                        lineStyle: {
                            color: '#DDDDDD',
                            type:'solid'
                        },
                    },                                                  
                    },                
                    legend: {
                        show: true,
                        x: this.$route.query.identification ? '240' : '290',
                        y: this.$route.query.identification ? '18' : '26',
                        icon: 'circle',
                        itemGap: this.$route.query.identification ? 10 : 25,
                        itemWidth: 8,
                        itemHeight: 7,
                        textStyle: {
                            color: '#666666',
                            height: 10,
                            rich: {
                            a: {
                                verticalAlign: 'middle',
                            },
                        }
                        },
                        data: this.BidsDataList.legend
                    },
                    xAxis: [{
                        type: 'category',
                        boundaryGap: 0,
                        axisLine: {
                        show: Math.max(...this.BidsDataList.series[0].data,...this.BidsDataList.series[1].data) == 0 ? true : false,
                        lineStyle: {
                        color: '#DDDDDD'
                        }
                    },
                    axisLabel: {
                        show:this.$route.query.identification ? false : true,
                        color: '#666666',
                        interval:this.screenWidth <= 1366 || checkDay(this.dataRange) < 30 ? "auto" : Math.ceil( this.BidsDataList.xAxis.data.length / 10),
                        padding:[8,0,0,0],
                        fontSize:this.screenWidth <= 1366 ? 10 : 12
                    },
                    splitLine: {
                        show: Math.max(...this.BidsDataList.series[0].data,...this.BidsDataList.series[1].data) == 0 ? false : true,
                        lineStyle: {
                            color: '#DDDDDD',
                            type: 'solid'
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    
                        data: this.BidsDataList.xAxis.data
                    }],
                    yAxis: [{
                            type: 'value',
                            name: '数量(个)',
                            minInterval:1, // 个数显示一个,无小数点
                            // min: 0,
                            // max: Math.ceil(this.BidsDataList.reportList[0].count/10)*10,
                            // interval: 5,
                            show:Math.max(...this.BidsDataList.series[0].data,...this.BidsDataList.series[1].data) == 0 ? false : true,
                        splitLine: {
                            show: Math.max(...this.BidsDataList.series[0].data,...this.BidsDataList.series[1].data) == 0 ? false : true,
                            lineStyle: {
                            color: '#DDDDDD',
                            type: 'solid'
                            }
                        },
                        axisLine: {
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            // padding:[2,2,2,2],
                            textStyle: {
                            color: '#666666'
                
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        // 坐标轴名称的文字样式
                        nameTextStyle: {
                        padding: [0,15,0,0],
                        color:'#666666'
                        },
                        },
                    ],
                    series: [{
                            name: this.BidsDataList.series[0].name,
                            type: 'line',
                            smooth:true,
                            symbolSize: 5,
                            showSymbol: false,
                            itemStyle: {
                                normal: {
                                    opacity:Math.max(...this.BidsDataList.series[0].data) == 0 ? 0 : 1,
                                    color:'#5ebbff',
                                    lineStyle: {
                                        color: "#5ebbff",
                                        width: 2,
                                        opacity:Math.max(...this.BidsDataList.series[0].data) == 0 ? 0 : 1,
                                    },
                                }
                            },
                            areaStyle: {
                                normal: {
                                    offset: 0.03,
                                    color:'#e6f5ff',
                                }
                            },
                            data: this.BidsDataList.series[0].data
                        },
                        {
                            name: this.BidsDataList.series[1].name,
                            type: 'line',
                            smooth:true,
                            stack: '总量',
                            symbolSize: 5,
                            showSymbol: false,
                            itemStyle: {
                                normal: {
                                    opacity:Math.max(...this.BidsDataList.series[1].data) == 0 ? 0 : 1,
                                    color: '#72d8c0',
                                    lineStyle: {
                                        color: "#72d8c0",
                                        width: 2,
                                        opacity:Math.max(...this.BidsDataList.series[1].data) == 0 ? 0 : 1,
                                    },
                                }
                            },
                            areaStyle: {
                                normal: {
                                offset: 0.05,
                                color: '#cdedf2', 
                                }
                            },
                            data: this.BidsDataList.series[1].data
                        },
                
                    ]
                };
                this.myChart.setOption(option);
                window.addEventListener("resize", () => {
                    if(this.$route.query.identification) {
                        var resize = {
                        width: this.screenWidth - 21,
                        };
                        this.myChart.resize(resize)
                    } else {
                        this.myChart.resize()
                    }
                    })       
        },
        // 获取地图数据
        getChnaDataList(){
            let _this = this
            let url = Urls.getEchartsBidsReportDataByMapOfChina 
            let params = {
            orgCode:this.orgCode,
            startTime:this.dataRange.length?this.dataRange[0]:'',
            endTime:this.dataRange.length?this.dataRange[1]:'',
            itemCode:''
            }
            this.$root.doPost(url,params,function(server_data){
                // 用户没有登录
            if( !_this.$root.isUserLogin(server_data)){
            return;
            }

            // 应用错误
            if(server_data.error){
                _this.$root.showGlobalError(server_data.error);
                return;
            }
            _this.ChanDataList = server_data.data
            })
        },
        // initChart1(){
        //     let ChanDataList = this.ChanDataList
        //     let Chart1 = this.$echarts.getInstanceByDom(this.$refs.ChinaMap);   
        //     if (Chart1 == null) {
        //     this.myChart1 = this.$echarts.init(this.$refs.ChinaMap);
        //     }  
        //     this.$echarts.registerMap('chinaMaps',China)
        //     let option = {
        //         textStyle: {
        //             fontFamily: 'PingFang-M'
        //         },
        //         title:{
        //             text: '全国投/中标数据',
        //             top:'24',  
        //             left:this.$route.query.identification ? '20' : '30',
        //             textStyle:{
        //                 fontWeight:500,
        //             }
        //         },
        //         tooltip: {
        //             show: true,
        //             formatter:(params)=>{
        //                 let str = `
        //                         <div>${params.data.name}</div>
        //                         <div>投标：${params.data.bidMapData.count}个（${params.data.bidMapData.totalCount}人）</div>
        //                         <div>中标：${params.data.biddingMapData.count}个（${params.data.biddingMapData.totalCount}人）</div>
        //                 `
        //                 return str
        //             }
        //         },
        //         series: [{
        //             type: 'map',
        //             map: 'chinaMaps',
        //             aspectScale: 0.75,
        //             layoutCenter: ["50%", "50%"], //地图位置
        //             layoutSize:this.$route.query.identification ? '90%' : '120%',
        //             roam: this.$route.query.identification ? false : true,
        //             geoIndex: 0,
        //             label:{
        //                 normal:{
        //                     show:this.$route.query.identification ? false : true,
        //                     textStyle:{
        //                         color:'#333333'
        //                     }   
        //                 },
        //             },
        //             itemStyle: {
        //                 normal: {
        //                     borderColor: '#a5b9ec',
        //                     borderWidth: 0.8,
        //                     areaColor: {
        //                         type: 'linear-gradient',
        //                         colorStops: [{
        //                             offset: 0,
        //                             color: '#f4f4f4' // 0% 处的颜色
        //                         }],
        //                         global: true // 缺省为 false
        //                     },
        //                 },
        //                 emphasis: {
        //                     areaColor: '#8cd5e6',
        //                     borderColor: '#5cbbd1',
        //                 }
        //             },
        //             zlevel: 1,
        //             data:ChanDataList
        //         },]
        //     }
        //     this.myChart1.setOption(option);
        // }
        mapEcharts(){
            loadScript('https://cdn.jsdelivr.net/npm/echarts@5.3.1/dist/echarts.min.js').then(() => {
                let ChanDataList = this.ChanDataList;
                var myEcharts = echarts.init(this.$refs.ChinaMap);
                echarts.registerMap('chinaMaps',China);
                let option = {
                    textStyle: {
                        fontFamily: 'PingFang-M'
                    },
                    title:{
                        text: '全国投/中标数据',
                        top:'24',  
                        left:this.$route.query.identification ? '20' : '30',
                        textStyle:{
                            fontWeight:500,
                        }
                    },
                    tooltip: {
                        show: true,
                        formatter:(params)=>{
                            let str = `
                                    <div>${params.data.name}</div>
                                    <div>投标：${params.data.bidMapData.count}个（${params.data.bidMapData.totalCount}人）</div>
                                    <div>中标：${params.data.biddingMapData.count}个（${params.data.biddingMapData.totalCount}人）</div>
                            `
                            return str
                        }
                    },
                    series: [{
                        type: 'map',
                        map: 'chinaMaps',
                        aspectScale: 0.75,
                        layoutCenter: ["50%", "50%"], //地图位置
                        layoutSize:this.$route.query.identification ? '90%' : '120%',
                        roam: this.$route.query.identification ? false : false,
                        geoIndex: 0,
                        label:{
                            normal:{
                                show:this.$route.query.identification ? false : true,
                                textStyle:{
                                    color:'#333333'
                                }   
                            },
                        },
                        itemStyle: {
                            normal: {
                                borderColor: '#a5b9ec',
                                borderWidth: 0.8,
                                areaColor: {
                                    type: 'linear-gradient',
                                    colorStops: [{
                                        offset: 0,
                                        color: '#f4f4f4' // 0% 处的颜色
                                    }],
                                    global: true // 缺省为 false
                                },
                            },
                            emphasis: {
                                areaColor: '#8cd5e6',
                                borderColor: '#5cbbd1',
                            }
                        },
                        select: {
                            disabled:this.$route.query.identification ? false : true,
                            itemStyle: {
                                areaColor: "#8cd5e6",
                            }
                        },
                        zlevel: 1,
                        data:ChanDataList
                    },]
                }
                myEcharts.setOption(option);
            });
        }
    },
    watch:{       
        BidsDataList(){
            this.$nextTick(function () {
                var myEvent = new Event('resize'); // 创建一个支持冒泡且不能被取消的resize事件
                window.dispatchEvent(myEvent); // 事件可以在任何元素触发
            })
            this.initChart()
        },
        ChanDataList(){
            // this.initChart1()
            this.mapEcharts()
        }
  }
}
</script>

<style lang="scss" scoped>
#bidsData{
    .topBox{
        display: flex;
        width: 100%;
        justify-content: space-between;
        margin-top: 00.29rem;
        .DataBox{
            box-sizing: border-box;
            width: calc(25% - 0.24rem);
            height: 1.1rem;
            background-color: #fff;
            -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            border-radius:0.1rem;
            padding:0.21rem 0.23rem 0.27rem 0.27rem;
            &:first-child{
                width: calc(25% - 0.12rem);
            }
            .smBox {
                display: flex;
                justify-content: space-between;
                .imgBox{
                    margin-top: -0.2rem;
                }
            }
        }
    }
    .BigCenterBox{
        .centerBox{
        width: 100%;
        height: 4.8rem;
        margin-top: 0.24rem;
        background-color: #fff;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
         border-radius:0.1rem;
         #bidsDataEcharts{
            height: 4.8rem;
            width: 100%;
         }
        }
    }
    .BigBottomBox{
        .BottomBox{
        display: flex;
        width: 100%;
        height: 5.15rem;
        margin-top: 0.24rem;
        #ChinaMap{
            width: 60%;
            height: 100%;
            background-color: #fff;
            -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            border-radius:0.1rem;
            margin-right: 0.24rem;
        }
        .Ranking{
            width: 40%;
            height: 100%;
            position: relative;
            background-color: #fff;
            -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
            border-radius:0.1rem;
            .top-Name{
                display: flex;
                padding-top: 0.24rem;
                padding-left: 0.32rem;
                height: 0.3rem;   
                align-items: center;                             
                i{
                    display: inline-block;
                    height: 0.15rem;
                    width: 0.15rem;
                    // background-color: red;
                    color: #5bd1b5;
                    font-size: 0.17rem;
                    font-style: normal;
                    margin-right: 0.1rem;
                }
                p{
                    font-size: 0.18rem;
                    color: #333333;
                }
            }
            .tablist{
                width: 90%;
                margin: 18px auto 0;
                display: flex;
                li{
                    padding: 5px 0;
                    width: 86px;
                    margin-right: 28px;
                    color: #999;
                    font-size: 14px;
                }
                li.active{
                    color: #57B9FF;
                    border-bottom: 1px solid #57B9FF;
                }
                li:hover{
                    cursor: pointer;
                }
            }
            #S-dataSort{
                width: 100%;
                color:#333333;
                .bottom-Data{
                    .table-Box{
                        margin-left: 0.32rem;
                        margin-bottom: 0.33rem;
                        margin-top: 0.2rem;
                        font-size: 0.14rem;
                        width: 93%;
                        .herader-Box{
                            font-size: 0.14rem;
                            color: #999999;
                        }
                    }
                }                   
            }
            .nodata_box{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: calc(100% - 100px);
                    span{
                        font-size: 16px;
                        color: #ccc;
                        line-height: 44px;
                    }
            } 
        }
        }
    }
    .red{
        color: #ff0707
    }
    .orange{
        color: #ff771f
    }
    .yellow{
        color: #ffa72d
    }
}
@media screen and (max-width: 768px) {
    #bidsData{
        .topBox{
            margin-top: 0.12rem;
            padding: 0 0.12rem;
            flex-direction: column;
            box-sizing: border-box;
            .DataBox{
                width: 100%;
                margin-top: 0.1rem;
                &:first-child{
                    width: 100%;
                    margin-top: 0;
                }
            }
        } 
        .BigCenterBox{
            box-sizing: border-box;
            padding: 0 0.12rem;
            .centerBox{
                margin-top: 0.12rem;
                height: 3.5rem;
                #bidsDataEcharts{
                    height: 3.5rem;
                }
            }
        }
        .BigBottomBox{
            box-sizing: border-box;
            padding: 0 0.12rem;
            .BottomBox{
                margin-top: 0.12rem;
                flex-direction: column;
                height: 10.3rem;
                #ChinaMap{
                    height: 5.15rem;
                    width: 100%;
                    background-color: #fff !important;
                    margin-right: 0;
                }
                .Ranking{
                    height: 5.15rem;
                    width: 100%;
                    margin:0.12rem  0;
                    .top-Name{
                        padding-left: 0.2rem;
                    }
                    #S-dataSort .bottom-Data .table-Box{
                        margin-left: 0.2rem;
                    }
                }

            }
        }
    }
}

</style>
<style lang="scss">
    @media screen and (max-width: 768px) {
       #bidsData{
         .queryCondition {
           margin-bottom: 0;
         }
       }
    }
</style>


// WEBPACK FOOTER //
// bidsData.vue?b3e08b3c